import React from 'react';
import './skill.css';
import {BsPatchCheckFill} from 'react-icons/bs';
const Skill = () => {
  return (
	<section id="skill">
    <h5>What Skills I have</h5>
    <h2>My Skills</h2>

    <div className="container experience__container"> 
      <div className="experience__frontend">
        <h3>Frontend Development</h3>
        <div className="experience__content">
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>HTML</h4>
              <small className='text-light'>Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>CSS</h4>
              <small className='text-light'>Intermediate</small>
            </div>
          </article>
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>Javascript</h4>
              <small className='text-light'>Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>Bootstrap</h4>
              <small className='text-light'>Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>Angular</h4>
              <small className='text-light'>Intermediate</small>
            </div>
          </article>
          <article className="experience__details">
            <BsPatchCheckFill />
            <div>
              <h4>React</h4>
              <small className='text-light'>Experienced</small>
            </div>
          </article>
        </div>
      </div>

      {/* Backend */}
      <div className="experience__backend">
        <h3>Backend Development</h3>
        <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>Node JS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>MongoDB</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>MySQL</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>Spring</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>PHP</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill />
              <div>
                <h4>React</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div> 
      </div>
    </div>
  </section>
  )
}

export default Skill;
